// extracted by mini-css-extract-plugin
export default {"form":"currency-config_form__MygUw","row":"currency-config_row__xhanw","name":"currency-config_name__nOkYj","value":"currency-config_value__kDSoY"};